import React from 'react';
import { Image } from 'lucide-react';

interface ImagePreviewProps {
  src: string;
  fileName: string;
}

export function ImagePreview({ src, fileName }: ImagePreviewProps) {
  return (
    <div className="h-full flex flex-col items-center justify-center bg-gray-50 p-8">
      <div className="max-w-full max-h-[70%] overflow-auto rounded-lg shadow-md border border-gray-200 bg-white p-2">
        <img
          src={src}
          alt={fileName}
          className="max-w-full max-h-full object-contain"
        />
      </div>
      <div className="mt-4 flex items-center gap-2 text-sm text-gray-500">
        <Image className="h-4 w-4" />
        {fileName}
      </div>
    </div>
  );
}
